import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DeviceInsights from './DeviceInsights';
import SoftwareAssets from './SoftwareAssets';
import AvailablePatches from './AvailablePatches';
import DiscoveredAgents from './DiscoveredAgents';

const InfoDeviceInsight: React.FC<{ deviceData?: any }> = ({ deviceData }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // determine whether to show Discovered Agents tab
  const showDiscovered = deviceData?.agentLogonAs !== 'LocalAccount' && deviceData?.agentLogonAs !== null;

  // extract view from query param
  const queryParams = new URLSearchParams(location.search);
  const viewParam = queryParams.get('view') as 'Device Insights' | 'Software Assets' | 'Available Patches' | 'Discovered Agents' | null;

  // build tabs list conditionally
  const tabs = ['Device Insights', 'Software Assets', 'Available Patches', ...(showDiscovered ? ['Discovered Agents'] : [])] as const;

  // ensure initial view falls back if it's not allowed
  const initialView = viewParam && (tabs as readonly string[]).includes(viewParam) ? viewParam : 'Device Insights';

  const [activeView, setActiveView] = useState<'Device Insights' | 'Software Assets' | 'Available Patches' | 'Discovered Agents'>(
    initialView,
  );

  // keep URL query in sync when tab changes
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set('view', activeView);
    navigate({ search: params.toString() }, { replace: true });
  }, [activeView, location.search, navigate]);

  return (
    <div className="p-6 bg-[#1C1C1D] text-white">
      {/* Toggle Buttons */}
      <div className="flex items-center mb-5">
        <div className="flex rounded-lg overflow-hidden border border-gray-500 shadow-lg">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveView(tab as any)}
              className={`text-md px-4 py-2 flex items-center gap-1 transition-all duration-300 ease-in-out transform hover:scale-105 border-l first:border-l-0 border-gray-500 ${
                activeView === tab
                  ? 'bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white shadow-lg'
                  : 'bg-gray-600 hover:bg-gray-700 text-white opacity-70'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* Conditional Rendering */}
      {activeView === 'Device Insights' && <DeviceInsights deviceData={deviceData} />}
      {activeView === 'Software Assets' && <SoftwareAssets deviceData={deviceData} />}
      {activeView === 'Available Patches' && <AvailablePatches deviceData={deviceData} />}
      {showDiscovered && activeView === 'Discovered Agents' && <DiscoveredAgents deviceData={deviceData} />}
    </div>
  );
};

export default InfoDeviceInsight;
